export default __webpack_public_path__ + "static/media/completion-velocity.3e225d24.svg";